import { Dictionary } from '../../utils/types'

export const filterKeysToTranslationsMapper: Dictionary<string> = {
  orderIds: 'form:OrderId',
  dateFrom: 'form:OrderDateFrom',
  dateTo: 'form:OrderDateTo',
  orderStatus: 'form:OrderStatus',
  paymentMethod: 'form:PaymentType'
}
